<template>
    <div class="t-a-c">
        <ul class="page-wrap d-i-b">
            <!-- prev -->
            <li :class="['page-item page-border d-i-b m-l-0 mb-f-s-24', 'page-item--prev', {'page-item--disabled' : index === 1}]" :style="pageStyle" @click="prev">prev</li>
            <!-- first -->
            <li :class="['page-item page-border d-i-b p-r mb-f-s-24', 'page-item--first', {'page-item--disabled' : index === 1}]" :style="pageStyle" @click="first">first</li>
            <li :class="['page-item d-i-b p-r mb-f-s-24', 'page-item--more']" v-if="showPrevMore" :style="pageNumStyle">...</li>
            <li :class="['page-item d-i-b p-r mb-f-s-24', {'page-item--current' : index == pager}]" ref="pageItem" v-for="(pager,i) in pagers" :key="i" :style="pageNumStyle" @mousemove="addActiveBg(i)" @mouseout="removeActiveBg(i)" @click="go(pager)">{{ pager }}</li>
            <li :class="['page-item d-i-b p-r mb-f-s-24', 'page-item--more']" v-if="showNextMore" :style="pageNumStyle">...</li>
            <!-- last -->
            <li :class="['page-item page-border d-i-b p-r mb-f-s-24', 'page-item--last', {'page-item--disabled' : index === pages}]" :style="pageStyle" @click="last">last</li>
            <!-- next -->
            <li :class="['page-item page-border d-i-b p-r mb-f-s-24', 'page-item--next', {'page-item--disabled' : index === pages}]" :style="pageStyle" @click="next">next</li>
        </ul>
    </div>
</template>
<script>
    import Util from '@util/index.js';
    export default {
        props: ['info'],
        data() {
            return {
                perPages: 3, //当前可见页码
                index: this.info.pageIndex, //当前页码
                limit: this.info.pageSize, //每页显示条数
                size: this.info.total || 1, //总页码
                showPrevMore: false,
                showNextMore: false
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.pageItem.forEach(e => {
                    // 如果不设置activeBgColor属性的话，可以在父级通过css设置当前页码的背景色
                    if (e.className.indexOf('page-item--current') > -1) {
                        e.style = this.setActiveCommonStyle(this.info.pagestyle);
                    } else {
                        e.style = this.setCommonStyle(this.info.pagestyle);
                    }
                });
            })
        },
        computed: {
            //计算总页码
            pages() {
                return Math.ceil(this.size / this.limit)
            },
            //计算页码，当count等变化时自动计算
            pagers() {
                const array = []
                const perPages = this.perPages//可见页码数3
                const pageCount = this.pages//页码总数2
                let current = this.index//当前页码1
                const _offset = (perPages - 1) / 2//1
                const offset = {
                    start: current - _offset,//0
                    end: current + _offset//2
                }
                //-1, 3
                if (offset.start < 1) {
                    offset.end = offset.end + (1 - offset.start)//3
                    offset.start = 1//1
                }
                if (offset.end > pageCount) {
                    offset.start = offset.start - (offset.end - pageCount)
                    offset.end = pageCount
                }
                if (offset.start < 1) offset.start = 1
                this.showPrevMore = (offset.start > 1)
                this.showNextMore = (offset.end < pageCount)
                for (let i = offset.start; i <= offset.end; i++) {
                    array.push(i)
                }
                
                return array;
            },
            //页码样式
            pageStyle() {
                const style = this.setCommonStyle(this.info.pagestyle);
                return this.info.pagestyle ? style : '';
            },
            pageNumStyle() {
                const style = this.setCommonStyle(this.info.pagestyle);
                return this.info.pagestyle ? style : '';
            }
        },
        methods: {
            prev() {
                if (this.index > 1) {
                    this.go(this.index - 1)
                }
            },
            next() {
                if (this.index < this.pages) {
                    this.go(this.index + 1)
                }
            },
            first() {
                if (this.index !== 1) {
                    this.go(1)
                }
            },
            last() {
                if (this.index != this.pages) {
                    this.go(this.pages)
                }
            },
            go(_page) {
                if (this.index !== _page) {
                    this.index = _page;
                    this.$nextTick(() => {
                        this.$refs.pageItem.forEach((e, index) => {
                            if (e.className.indexOf('page-item--current') > 0) {
                                e.style = this.setActiveCommonStyle(this.info.pagestyle);
                            } else {
                                e.style = this.setCommonStyle(this.info.pagestyle);
                            }
                        })
                    })
                    //父组件通过change方法来接受当前的页码
                    this.$emit('change', this.index);
                }
            },
            addActiveBg(_i) {
                this.$refs.pageItem.forEach((e, index) => {
                    if (index == _i) {
                        e.style = this.setActiveCommonStyle(this.info.pagestyle);
                    }
                });
            },
            removeActiveBg(_i) {
                this.$refs.pageItem.forEach((e, index) => {
                    if (index == _i && e.className.indexOf('page-item--current') < 0) {
                        e.style = this.setCommonStyle(this.info.pagestyle);
                    }
                })
            },
            setCommonStyle(_info) {
                if (Util.setStyle(_info)) {
                    return 'background:' + Util.setStyle(_info.bgColor) + ';color:' + Util.setStyle(_info.color) + ';border-radius:' + ';border: 1px solid ;';
                } else {
                    return '';
                }
            },
            setActiveCommonStyle(_info) {
                if (Util.setStyle(_info)) {
                    return 'background:' + Util.setStyle(_info.activeBgColor) + ';color:' + Util.setStyle(_info.color) + ';border-radius:' + ';border: 1px solid;';
                } else {
                    return '';
                }
            }
        },
        // watch: {
        // pageIndex(val) {
        //     this.index = val || 1
        // },
        // pageSize(val) {
        //     this.limit = val || 10
        // },
        // total(val) {
        //     this.size = val || 1
        // }
        // }
    }
</script>

<style lang="less" scoped>
    .page-wrap {
        padding: 0;
        margin: .5rem 0;
        font-size: 0;
        >.page-item {
            padding: .08rem .133333rem;
            line-height: 1.42857143;
            margin: 0 .066667rem;
            cursor: pointer;
            color: #fff;
            border-radius: .133333rem;
            text-align: center;
            &:hover {
                // background-color: #65aace;
                // color: #0275d8;
            }
            &.page-item--disabled,
            &.page-item--more {
                color: #fff;
            } //禁用
            &.page-item--disabled {
                cursor: not-allowed;
                opacity: .75;
            }
            &.page-item--more,
            &.page-item--current {
                cursor: default;
            } //选中
            &.page-item--current {
                color: #fff;
                z-index: 1;
                opacity: .4;
            }
        }
        >.page-border {
            min-width: 1.333333rem;
            border-radius: .133333rem;
        }
    }
</style>




// WEBPACK FOOTER //
// client/smsgz/components/guide/page-divide.vue